// === packages
import React from 'react';
// === css
import styles from './../css-modules/mainSlideStatic.module.css'
// === components
import FlyInText from './animation/flyInText';
// === image
import image from './../../asset/images/homepage/mainImg/main_banner_1920.jpg'




function MainSlideStatic (props){
    // states
    // handlers
    // import images  
    // right handler
    // condition
    return(
        <div className={styles.slide}>
        <div className={styles.slide__container}>
                    <div className={styles.slide__container__imgWrapper}>
                        <img className = {styles.slide__container__imgWrapper__img} src = {image}></img>
                        </div>
                        <div className={styles.slide__container__animation__wrapper}>
                            <div className={styles.slide__container__animation}>
                                <FlyInText>Advanced Community Rehabilitation</FlyInText>
                            </div>
                        </div>
            </div>
            </div>
    )
}

export default MainSlideStatic;
